// Bootstrap CSS is centrally imported in App.scss - do not re-import here.
import "./home.scss";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import { Link } from 'react-router-dom';
import config from "../../config/config";
import {
    HomeScreenSizes, KEY_debug, KEY_patient, KEY_patient_name, SkipLocalization
} from "../../constants";
import { selectContentDictionary } from "../../reduxToolkit/features/contentSlice";
import { useAppSelector } from "../../reduxToolkit/hooks";
import { getImageSrcset, toastError } from "../../services/appService";
import { getPatientName } from "../../services/epicServices";
import { readFromStorage, removeFromStorage, writeToStorage } from "../../services/storageServies";
import {
    getRandomImage, isAndroidApp, isIosApp, isMobileApp, isPrintingSupported, isTouchCapable,
    redirectToUrl
} from "../../services/utilities";
import { ImageSrcSet, Patient } from "../../types/interfaces";
import { HealthBlog } from "../HealthBlog/HealthBlog";
import MyMhBanner from "../MyMhBanner/MyMhBanner";
import Card from "../shared/Card/Card";
// import Dialog from '../shared/Dialog/Dialog';
import RoundActionBox from "../shared/RoundActionBox/RoundActionBox";
import MyMhSpinner from "../shared/Spinner/MyMhSpinner";
import SquareActionBox from "../shared/SquareActionBox/SquareActionBox";
import Survey from "../Survey/Survey";
import BillPayIcon from "./Bills Icon.svg?react";
import CostEstimateIcon from "./Calculator Icon.svg?react";
import SchedulingIcon from "./Calendar Icon.svg?react";
import GetCareIcon from "./Clock Icon.svg?react";
import MyMemorialHermannLogo from "./Home Screen Logo.png";
// import MyMemorialHermannIcon from './Home Screen Logo.svg?react';
import LabResultIcon from "./Labs Icon.svg?react";

import type Client from "fhirclient/Client";
const Home = ({ fhirClient: client }: { fhirClient?: Client }) => {
  const navigate = useNavigate();
  const [callingAPI, setCallingAPI] = useState<boolean>(false);
  const [userName, setUserName] = useState<string | null | undefined>(null);


  // const [headImage, setHeadImage] = useState<string | undefined>(undefined);
  const [headImageSrcSet, setHeadImageSrcSet] = useState<ImageSrcSet | undefined>(undefined);
  const [findCareImageSrcSet, setFindCareImageSrcSet] = useState<ImageSrcSet | undefined>(undefined);
  // START: GitHub Copilot Generated Code
  const contentDictionary = useAppSelector(state => selectContentDictionary(state, 'home'));
  // const isContentLoading = useAppSelector(selectIsLoadingForCurrentLanguage);
  // END: GitHub Copilot Generated Code
  // const [showMarketplaceDialog, setShowMarketplaceDialog] = useState<boolean>(false);
  const [dbgMsg, setDbgMsg] = useState<string | null>(null);

  const noName = 'noName';
  const browserView = !isMobileApp();
  // const withIos = isIosApp();

  useEffect(() => {
    // setHeadImage(getRandomImage([image1, image2, image3, image4]));
    const headImg = getRandomImage(['/images/home/image1.jpg', '/images/home/image2.jpg', '/images/home/image3.jpg', '/images/home/image4.jpg']);
    const headImgSpec = getImageSrcset({ imageFileNameTemplate: headImg!, ScreenSizes: HomeScreenSizes, sameSize: true });
    const findCareImgSpec = getImageSrcset({ imageFileNameTemplate: '/images/home/find-care.jpg', ScreenSizes: HomeScreenSizes, sameSize: true });
    // if (!browserView) {
    //   const mobileScreenImageSizes = getMobileImageSizes();
    //   headImgSpec.sizes = mobileScreenImageSizes;
    //   findCareImgSpec.sizes = mobileScreenImageSizes;
    // }
    setHeadImageSrcSet(headImgSpec);
    setFindCareImageSrcSet(findCareImgSpec);

    let patientName = readFromStorage<string | null | undefined>(KEY_patient_name);
    if (patientName) {
      setUserName(patientName);
    }
    else {
      const patient = readFromStorage<Patient>(KEY_patient);
      if (patient) {
        patientName = getPatientName({ patient, type: 'Given' });
        setUserName(patientName);
      }
      else if (client) {
        setCallingAPI(true);
        client.patient.read().then((patient: Patient) => {
          writeToStorage<Patient>(KEY_patient, patient);
          patientName = getPatientName({ patient, type: 'Given' });
          setUserName(patientName);
        }).catch((e: unknown) => {
          console.error(`Failed to retrieve FHIR patient due to: ${JSON.stringify(e)}`);
          patientName = noName;
          setUserName(patientName);
          writeToStorage(KEY_patient_name, patientName);
        }
        ).finally(() => setCallingAPI(false));
      }
      else {
        console.log('No FHIR client is available. Patient-only experience is disabled.');
      }
    }
  }, []);

  // contentMiddleware automatically loads content when language changes — no useEffect needed here

  // const getMobileImageSizes = () => {
  //   const sizesArray: string[] = DefaultScreenSizes.length == 1 ? [`${DefaultScreenSizes[0]}px` ]: DefaultScreenSizes.slice(0, DefaultScreenSizes.length-1).map(size=>`(max-width: ${size.width}px) 100vw`);
  //   if (DefaultScreenSizes.length > 1) { sizesArray.push(`100vw`); }
  //   const sizesStr = sizesArray.join(', ');
  //   return sizesStr;
  // };

  const loading = callingAPI || !headImageSrcSet || !findCareImageSrcSet;

  if (loading)
    return <MyMhSpinner />;

  const onLogoClicked = () => {
    setDbgMsg(null);
    removeFromStorage(KEY_debug);
  };

  const gotoMyChart = () => {
    if (userName)
      navigate(config.urlConfig.gotoMychartHome);
    else
      navigate(config.urlConfig.gotoMychartLogin);
  };

  const gotoTestResult = () => {
    navigate(config.urlConfig.gotoTestResult);
  };

  const displayDebuggingInfo = () => {
    const env = (config.env || '').toLowerCase();
    if (env == 'prd' || env == 'prod') {
      return;
    }
    writeToStorage(KEY_debug, 'true');
    const info = {
      Env: config.env,
      UserName: userName,
      PreLoginUrl: window.location.href,
      IsIosApp: isIosApp(),
      IsAndroidApp: isAndroidApp(),
      UserAgents: window.navigator.userAgent,
      SkipLocalization: SkipLocalization,
      SupportWebAuthn: typeof PublicKeyCredential != 'undefined',
      SupportTouch: isTouchCapable(),
      SupportPrint: isPrintingSupported(),
      BlockItUrlConfig: {
        regular: config.urlConfig.blockItUrl,
        urgent: config.urlConfig.blockItQuickCareUrl,
      },
    };
    const msg = JSON.stringify(info);
    setDbgMsg(msg);
  };

  const gotoPayBill = () => {
    navigate(userName ? config.urlConfig.payBill : config.urlConfig.payAsGuest);
  };

  const gotoCostEstimate = () => {
    navigate(userName ? config.urlConfig.costEstimate : config.urlConfig.guestCostEstimate);
  };

  const onImageClicked = () => {
  };

  const getLabel = () => {
    return userName == noName ? `Your ${contentDictionary?.myChartLabel}` : `${userName}'s ${contentDictionary?.myChartLabel}`;
  };

  const renderHeaderCard = () => (
    <Card>
      <div className='head-frame' onClick={() => onImageClicked()}>
        <div className='head-frame-border'>
          <div className='head-frame-content'>
            <img
              src={headImageSrcSet!.src}
              srcSet={headImageSrcSet!.srcSet}
              sizes={headImageSrcSet!.sizes}
              width={1000}
              className='head-image'
              alt={contentDictionary?.imageLabel}
              fetchPriority='high'
              decoding='async'
            />
          </div>
        </div>
      </div>
      <div className='logo-frame padding-x' onClick={onLogoClicked}>
        {/* <MyMemorialHermannIcon
          className='my-mh-logo'
          aria-label={contentDictionary?.mhLogoLabel}
          onClick={onLogoClicked}
        /> */}
        <img
          className='my-mh-logo'
          src={MyMemorialHermannLogo}
          alt={contentDictionary?.mhLogoLabel}
          width={374}
          loading='eager'
          decoding='async'
        />
      </div>
    </Card>
  );

  const renderLoginCard = () => (
    <Card>
      <div className='portal-login padding-x'>
        <button className='btn primary' onClick={() => gotoMyChart()}>
          {userName ? getLabel() : contentDictionary?.loginToMyChart}
        </button>
      </div>
    </Card>
  );

  const renderFindCareCard = () => (
    <Card>
      <div className='find-care-heading padding-x'>
        {contentDictionary?.findCareLabel}
      </div>
      <div className='find-care-container-spacing'>
        <div className='find-care-container'>
          <div className='find-care-image-container'>
            <img
              src={findCareImageSrcSet!.src}
              srcSet={findCareImageSrcSet!.srcSet}
              sizes={findCareImageSrcSet!.sizes}
              width={1000}
              alt='Find Care'
              className='find-care-image'
              onClick={() => displayDebuggingInfo()}
              loading='lazy'
              decoding='async'
            />
          </div>
          <div className='find-care-actions'>
            <SquareActionBox
              IconComponent={SchedulingIcon}
              label={contentDictionary?.scheduleNowLabel}
              onClick={() =>
                navigate(
                  config.urlConfig.scheduling,
                )
              }
            />
            <SquareActionBox
              IconComponent={GetCareIcon}
              label={contentDictionary?.getQuickCareLabel}
              onClick={() => navigate(config.urlConfig.getCareNow)}
            />
          </div>
        </div>
      </div>
    </Card>
  );

  const renderMiscServicesCard = () => (
    <Card extraCalss='flex-expand'>
      <div className='footer'>
        <div className='footer-frame padding-x'>
          <div className='w-33'>
            <RoundActionBox
              IconComponent={LabResultIcon}
              label={contentDictionary?.testResultsLabel}
              onClick={gotoTestResult}
            />
          </div>
          <div className='w-33'>
            <RoundActionBox
              IconComponent={BillPayIcon}
              label={
                userName ? contentDictionary?.payBillLabel : contentDictionary?.payAsGuestLabel
              }
              onClick={gotoPayBill}
            />
          </div>
          <div className='w-33'>
            <RoundActionBox
              IconComponent={CostEstimateIcon}
              label={contentDictionary?.estimatCostsLabel}
              onClick={gotoCostEstimate}
            />
          </div>
        </div>
      </div>
    </Card>
  );




  return (
    <div className='w-100 h-100 row no-top-banner'>
      <h2 className='d-none'>Home</h2>
      {browserView && (
        <aside className='col-6 d-none d-lg-block p-0 m-0 side-banner'>
          <MyMhBanner />
        </aside>
      )}
      <div className={`p-0 col-12 ${browserView ? 'col-lg-6' : ''}`}>
        <div className='w-100 h-100 position-relative d-flex flex-column justify-content-start align-items-center'>
          {loading && <MyMhSpinner />}
          {loading && <div className='w-100 screen-cover'></div>}
          <section className='w-100'>
            {renderHeaderCard()}
          </section>
          <section className='w-100'>
            {renderLoginCard()}
          </section>
          <hr className='divider' />
          <section className='w-100'>
            {renderFindCareCard()}
          </section>
          <hr className='divider' />
          <section className='w-100'>
            {renderMiscServicesCard()}
          </section>
          {/* <hr className='divider' /> */}
          {/* <section className='w-100 padding-x mb-20'>
            <div className='marketplace-block'>
              <div className='w-100 d-flex flex-row justify-content-between adjust-items-center'>
                <div className='marketplace-block-heading'>{contentDictionary?.marketplace}</div>
                <div className='label-external-link'>{contentDictionary?.externalLink}</div>
              </div>
              <div className='w-100 mt-8 mb-16'>
                {contentDictionary?.marketplaceText}
              </div>
              <div className='w-100 text-center'>
                <button className='btn primary-black'
                  // onClick={() => setShowMarketplaceDialog(true)}
                  onClick={() => redirectToUrl(config.urlConfig.valeHealthUrl, 'new')}
                >
                  {contentDictionary?.browserNow}
                </button>
              </div>
            </div>
          </section> */}
          <section className='w-100 blogs-block'>
            <div className='w-100 padding-x blogs-block-headline mb-16'>
              {contentDictionary?.healthBlog}
            </div>
            <HealthBlog
              // carouselType='Snapshot'
              // looping={true}
              carouselType='Scroll'
              looping={false}
              onError={
                () => {
                  toastError(contentDictionary?.healthBlogUnavailable || "Health & Wellness is unavaible at this moment. Please try again later.", 3000);
                }}
            />
          </section>

          <section className='w-100  padding-x'>
            <Survey />
          </section>
          <section className='w-100 home-support padding-x'>
            {contentDictionary?.help}
            {/* {!browserView ?
              <Link className='link' to={config.urlConfig.supportRoute} target='_blank'>{contentDictionary?.helpLink}</Link>
              :
              <a className='link'
                href={config.urlConfig.supportUrl}
                target='_blank'
                rel='noreferrer'>
                {contentDictionary?.helpLink}
              </a>
            } */}
            <a className='link'
              href={config.urlConfig.supportUrl}
              target='_blank'
              rel='noreferrer'>
              {contentDictionary?.helpLink}
            </a>
          </section>
          <section className='w-100 mt-16 home-disclaimer padding-x'>
            {contentDictionary?.disclaimer}
          </section>
          {dbgMsg && (
            <div className='w-100'>
              <div className='w-100 mb-12 alert alert-warning'>
                <strong>
                  For Debugging only. QA team please ignore the part below. Click
                  on the MH logo to dismiss this part.
                </strong>
              </div>
              <div className='w-100 padding-x mb-12'>{dbgMsg}</div>
            </div>
          )}
        </div>
      </div>

      {/* {showMarketplaceDialog &&
        <Dialog
          header={contentDictionary?.marketplaceDialogHeader}
          description={contentDictionary?.marketplaceDialogText}
          confirm={contentDictionary?.continue}
          cancel={contentDictionary?.cancel}
          onCancel={() => setShowMarketplaceDialog(false)}
          onConfirm={() => { setShowMarketplaceDialog(false); redirectToUrl(config.urlConfig.valeHealthUrl, 'new'); }}
          buttonLayoutClass='w-100 d-flex flex-column justify-content-start align-items-center'
          confirmButtonClass='w-100 btn primary mb-16'
          cancelButtonClass='w-100 cancel-link '
        />} */}
    </div>
  );
};

export default Home;
